import axios from 'axios';
import myShopClient from './nearlive';

export async function createUnifyShop(shopData) {
	const client = await myShopClient();
	const { data } = await client.post('/api/unify/create-shop', shopData);
	return data;
}

export async function registerEmailInHubspot(email, plan) {
	try {
		// Public endpoint - no authentication required for early lead capture
		await axios.post('/api/unify/register-email', { email, plan });
		// Fire and forget - we don't need to wait for or handle the response
	} catch (error) {
		// Silently fail - don't block the user flow
		console.log('HubSpot email registration failed (non-blocking):', error.message);
	}
}
